import axios from 'axios';
export const handleFieldChange =
    (field, setter, errorFields, setErrorFields) => (e) => {
        setter(e.target.value);
        if (errorFields[field]) {
            setErrorFields((prev) => {
                const newErrors = { ...prev };
                delete newErrors[field];
                return newErrors;
            });
        }
    };

// Product code (the "SKU" field, shown as "প্রোডাক্ট কোড" on the product
// page): at most 15 characters, enough for a barcode or an SKU like CDR-001.
// The backend refuses a longer one, except a code saved before the limit
// that is left unchanged.
export const PRODUCT_CODE_MAX = 15;
export const productCodeTooLong = (code) =>
    [...String(code ?? '').trim()].length > PRODUCT_CODE_MAX;

// Price validation function
export const handlePriceChange =
    (field, setter, errorFields, setErrorFields) => (e) => {
        const value = e.target.value;
        // Allow only numbers and decimal point
        const numericValue = value.replace(/[^0-9.]/g, '');
        // Prevent multiple decimal points
        const parts = numericValue.split('.');
        const finalValue =
            parts.length > 2
                ? parts[0] + '.' + parts.slice(1).join('')
                : numericValue;

        setter(finalValue);
        if (errorFields[field]) {
            setErrorFields((prev) => {
                const newErrors = { ...prev };
                delete newErrors[field];
                return newErrors;
            });
        }
    };

export const uploadCallback = (file) => {
    return new Promise((resolve, reject) => {
        const form_data = new FormData();
        form_data.append('photo', file);

        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                token: 'zesrxdyctuutydrszrestdrxy',
            },
        };

        const url = 'https://cdn.ecomtechbd.com/upload/desc';

        axios
            .post(url, form_data, config)
            .then((res) => {
                resolve({ data: { link: res.data } });
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const ImageUpload = async (imgFile) => {
    const image = new FormData();
    image.append('photo', imgFile);
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            token: 'zesrxdyctuutydrszrestdrxy',
        },
    };
    const url = 'https://cdn.ecomtechbd.com/upload';
    const res = await axios.post(url, image, config);
    return res.data;
};

export async function handleImageSetWrapperHelper(images, e, imageId) {
    const file = e.target.files[0];
    if (!file) return images;
    const imgUrl = await ImageUpload(file);
    if (imageId) {
        return images.map((img) =>
            img.id === imageId ? { ...img, url: imgUrl } : img
        );
    } else {
        return [...images, { id: Date.now(), url: imgUrl }];
    }
}
